import React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import InvestmentPage from "./InvestmentPage";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import TodayCollection from "./TodayCollection";
import AdminCollection from "./AdminCollection";
import CustomersPage from "./CustomersPage";
import CollectionsPage from "./CollectionsPage";
import NewCustomersPage from "./NewCustomersPage";
import CustomerDetailsPage from "./CustomerDetailsPage";
import InitialProfitPage from "./InitialProfitPage";
import DailyLoanToPayPage from "./DailyLoanToPayPage";
import WeeklyLoanToPayPage from "./WeeklyLoanToPayPage";
import LoanCustomersPage from "./LoanCustomersPage";
import DailyLoanCustomers from "./DailyLoanCustomers";
import WeeklyLoanCustomers from "./WeeklyLoanCustomers";
import NewLoansPage from "./NewLoansReport";
import AttendanceReportPage from "./AttendanceReportpage";
import AdvanceReportPage from "./AdvanceReportPage";
import "jspdf-autotable";

import html2pdf from "html2pdf.js";

const ReportPage = () => {
  const [todayDate, setTodayDate] = useState("");
  const [todayAgentDate, setTodayAgentDate] = useState("");
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startCustDate, setStartCustDate] = useState("");
  const [endCustDate, setEndCustDate] = useState("");
  const [customers, setCustomers] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [startLoanDate, setStartLoanDate] = useState("");
  const [endLoanDate, setEndLoanDate] = useState("");
  const navigate = useNavigate();
  const [startNewLoansDate, setStartNewLoansDate] = useState("");
  const [endNewLoansDate, setEndNewLoansDate] = useState("");
  const [loanToPayDate, setLoanToPayaDate] = useState("");
  const [investmentDate, setInvestmentDate] = useState("");
  const [showInvestmentPopup, setShowInvestmentPopup] = useState(false);
  const investmentRef = useRef();
  const [showCollectionPopup, setShowCollectionPopup] = useState(false);
  const [showAgentCollectionPopup, setShowAgentCollectionPopup] =
    useState(false);
  const [allAgentNames, setAllAgentNames] = useState([]);
  const [showAgentCustomersPopup, setShowAgentCustomersPopup] = useState(false);
  const [showAdminCollectionPopup, setShowAdminCollectionPopup] =
    useState(false);
  const [showAgentNewCustomersPopup, setShowAgentNewCustomersPopup] =
    useState(false);
  const [showCustomerDetailsLoanPopup, setShowCustomerDetailsLoanPopup] =
    useState(false);
  const [showInitialProfitPopup, setShowInitialProfitPopup] = useState(false);
  const [showLoanToPayDailyPopup, setShowLoanToPayDailyPopup] = useState(false);
  const [showLoanToPayWeeklyPopup, setShowLoanToPayWeeklyPopup] =
    useState(false);
  const [showLoanCustomersPopup, setShowLoanCustomersPopup] = useState(false);
  const [showDailyLoanCustomersPopup, setShowDailyLoanCustomersPopup] =
    useState(false);
  const [showWeeklyLoanCustomersPopup, setShowWeeklyLoanCustomersPopup] =
    useState(false);
  const [showNewLoansPopup, setShowNewLoansPopup] = useState(false);
  const [selectedAttendanceAgent, setSelectedAttendanceAgent] = useState("all");
  const [showAgentAttendancePopup, setShowAgentAttendancePopup] =
    useState(false);
  const [agentAttendance, setAgentAttendance] = useState([]);
  const [allAttendanceAgentId, setAllAttendanceAgentId] = useState("all");
  const [startAttendanceDate, setStartAttendanceDate] = useState("");
  const [endAttendanceDate, setEndAttendanceDate] = useState("");
  const [selectedAdvanceAgent, setSelectedAdvanceAgent] = useState("all");
  const [showAgentAdvancePopup, setShowAgentAdvancePopup] = useState(false);
  const [startAdvanceDate, setStartAdvanceDate] = useState("");
  const [endAdvanceDate, setEndAdvanceDate] = useState("");

  const baseURL = process.env.REACT_APP_BASE_URL;

  const formatToDisplayDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/fetchCustomers`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setAgents(response.data);
        console.log(agents);
      })
      .catch((error) => {
        console.error("Error fetching agents", error);
      });

    axios
      .get(`${baseURL}/getAllAdmin`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        console.log("Admins:", response.data);
        setAgentAttendance(response.data);
      })
      .catch((error) => {
        console.error("Error fetching admins", error);
      });

    const currentDate = new Date();
    const isoDate = currentDate.toISOString().split("T")[0];
    setTodayDate(isoDate);
    setTodayAgentDate(isoDate);
  }, []);

  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/getAllLoan`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setCustomers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Customers", error);
      });
  }, []);

  const fetchFont = async () => {
    try {
      const response = await fetch("/getFont/1");
      const data = await response.json();

      if (response.ok) {
        const fontData = data.font_data;
        const fontName = data.font_name;

        const fontBlob = await fetch(
          `data:application/x-font-ttf;base64,${fontData}`
        );
        const fontArrayBuffer = await fontBlob.arrayBuffer();
        const fontBytes = new Uint8Array(fontArrayBuffer);

        return {
          fontBytes,
          fontName,
        };
      } else {
        console.error("Failed to fetch font:", data.error);
        return null;
      }
    } catch (error) {
      console.error("Error fetching font:", error);
      return null;
    }
  };

  const handleAgentAttendanceChange = (selectedOption) => {
    console.log("Agents : ", agents);
    setSelectedAttendanceAgent(selectedOption.value);
    console.log("Selected value ", selectedAttendanceAgent);
  };

  const handleAgentAdvanceChange = (selectedOption) => {
    setSelectedAdvanceAgent(selectedOption.value);
  };

  const handleAgentAttendanceClosePopup = () => {
    setShowAgentAttendancePopup(false);
  };

  const handleAgentAdvanceClosePopup = () => {
    setShowAgentAdvancePopup(false);
  };

  const printToPDF = (
    fontData,
    fontName,
    printableContent,
    filename,
    orientation = "portrait"
  ) => {
    const doc = new jsPDF({ orientation, unit: "mm", format: "a4" });

    doc.addFileToVFS(fontName + ".ttf", fontData);
    doc.addFont(fontName + ".ttf", fontName, "normal");

    doc.setFont(fontName);
    doc.setFontSize(8);

    html2pdf()
      .from(printableContent)
      .set({
        filename,
        margin: 0,
        jsPDF: {
          orientation,
          unit: "mm",
          format: "a4",
        },
      })
      .save();
  };

  const handleAdminCollectionPrint = () => {
    const printableContent = document.getElementById(
      "printable-admincollections-content"
    );
    const dynamicFilename = "admincollection-report-" + ".pdf";

    fetchFont().then((fontData) => {
      printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
    });
  };

  const handleNewLoansPrint = () => {
    const printableContent = document.getElementById(
      "printable-newloans-content"
    );

    const dynamicFilename = "newloans-report.pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleAgentAttendancePrint = () => {
    const printableContent = document.getElementById(
      "printable-attendance-content"
    );

    const dynamicFilename = `attendance-report-${
      selectedAttendanceAgent || "all"
    }.pdf`;

    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleAgentAdvancePrint = () => {
    const printableContent = document.getElementById(
      "printable-advance-content"
    );

    const dynamicFilename = `advance-report-${
      selectedAdvanceAgent || "all"
    }.pdf`;

    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleInvestmentPrint = () => {
    const printableContent = document.getElementById("printable-content");

    const dynamicFilename = "investment/profit-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleLoanCustomersPrint = () => {
    const printableContent = document.getElementById(
      "printable-loancustomers-content"
    );

    const dynamicFilename = "loancustomers-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleDailyLoanCustomersPrint = () => {
    const filterInputs = document.querySelectorAll(".filter-input");
    filterInputs.forEach((input) => input.remove());

    const printableContent = document.getElementById(
      "printable-dailyloancustomers-content"
    );

    const dynamicFilename = "dailyloancustomers-report-" + ".pdf";
    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });

    const filtersContainer = document.querySelector(".filters-container");
    if (filtersContainer) {
      filterInputs.forEach((input) => filtersContainer.appendChild(input));
    }
  };

  const handleWeeklyLoanCustomersPrint = () => {
    const filterInputs = document.querySelectorAll(".filter-input");
    filterInputs.forEach((input) => input.remove());
    const printableContent = document.getElementById(
      "printable-weeklyloancustomers-content"
    );
    const dynamicFilename = "weeklyloancustomers-report-" + ".pdf";
    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
    const filtersContainer = document.querySelector(".filters-container");
    if (filtersContainer) {
      filterInputs.forEach((input) => filtersContainer.appendChild(input));
    }
  };

  const handleDailyLoanToPayPrint = () => {
    const printableContent = document.getElementById(
      "printable-dailyloantopay-content"
    );

    const dynamicFilename = "dailyLoantopay-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };
  const handleWeeklyLoanToPayPrint = () => {
    const printableContent = document.getElementById(
      "printable-weeklyloantopay-content"
    );

    const dynamicFilename = "weeklyLoantopay-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleInitialProfitPrint = () => {
    const printableContent = document.getElementById(
      "printable-initialprofit-content"
    );

    const dynamicFilename = "initialprofit-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleCustomerLoanDetailsPrint = () => {
    const printableContent = document.getElementById(
      "printable-customerDetails-content"
    );

    const dynamicFilename = "customerDetails-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "CustomFont",
          printableContent,
          dynamicFilename,
          "landscape"
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleAgentNewCustomersPrint = () => {
    const printableContent = document.getElementById(
      "printable-agentnewcustomers-content"
    );

    const dynamicFilename = "agentnewcustomers-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleAgentCustomersPrint = () => {
    const printableContent = document.getElementById(
      "printable-customers-content"
    );

    const dynamicFilename = "customers-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleCollectionPrint = () => {
    const printableContent = document.getElementById(
      "printable-collection-content"
    );

    const dynamicFilename =
      "today-collection-report-" + new Date().toISOString() + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(fontData, "CustomFont", printableContent, dynamicFilename);
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleAgentCollectionPrint = () => {
    const printableContent = document.getElementById(
      "printable-agentcollection-content"
    );

    const dynamicFilename = "today-agentcollection-report-" + ".pdf";

    fetchFont()
      .then((fontData) => {
        printToPDF(
          fontData,
          "NotoSansTamil",
          printableContent,
          dynamicFilename
        );
      })
      .catch((error) => {
        console.error("Error fetching font data:", error);
      });
  };

  const handleAgentChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    console.log("Agent Change Triggered. Value:", value);

    setSelectedAgent(value);
  };

  const handleAgentDateChange = (e) => {
    setTodayAgentDate(e.target.value);
  };

  const handleInvestmentChange = (e) => {
    setInvestmentDate(e.target.value);
  };

  const handleDateChange = (e) => {
    setTodayDate(e.target.value);
  };

  const handleAdminBasedCustomerDetails = () => {
    console.log("Selected Agent:", selectedAgent);

    if (selectedAgent === "all") {
      setShowAgentCustomersPopup(true);
      setAllAgentNames(["all"]);
    } else if (selectedAgent) {
      setShowAgentCustomersPopup(true);
      setAllAgentNames([selectedAgent]);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select an agent first.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };
  const handleAdminBasedAttendanceDetails = () => {
    console.log("Selected Attendance Agent ID:", selectedAttendanceAgent);

    if (!startAttendanceDate || !endAttendanceDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both start and end date.",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    if (selectedAttendanceAgent) {
      setShowAgentAttendancePopup(true);
      setAllAttendanceAgentId(selectedAttendanceAgent);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select an agent first.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const handleAgentAdvanceDetails = () => {
    console.log("Selected Agent ID:", selectedAttendanceAgent);

    if (!startAdvanceDate || !endAdvanceDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both start and end date.",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    if (selectedAdvanceAgent) {
      setShowAgentAdvancePopup(true);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select an agent first.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const handleCollectionClosePopup = () => {
    setShowCollectionPopup(false);
  };

  const handleViewClick = () => {
    setShowCollectionPopup(true);
  };

  const handleInvestmentClick = () => {
    if (!investmentDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select a date first.",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    setShowInvestmentPopup(true);
  };

  const customerOptions = customers.map((customer) => ({
    value: customer.loan_id,
    label: `${customer.customer_name} -- ${customer.loan_id}`,
  }));

  const agentOptions = Array.from(
    new Set(agents.map((agent) => agent.admin_name))
  ).map((name) => ({ value: name, label: name }));

  const uniqueAdmins = Array.from(
    new Map(agentAttendance.map((agent) => [agent.id, agent])).values()
  );
  const agentAttendanceOptions = [
    { value: "all", label: "All" },
    ...uniqueAdmins.map((agent) => ({
      value: agent.id,
      label: agent.name,
    })),
  ];

  const agentAdvanceOptions = [
    { value: "all", label: "All" },
    ...uniqueAdmins.map((agent) => ({
      value: agent.id,
      label: agent.name,
    })),
  ];

  useEffect(() => {
    console.log("Agents updated:", agents);
  }, [agents]);

  const handleAdminClick = () => {
    setShowAgentCollectionPopup(true);
  };

  const handleLoanCustomers = () => {
    setShowLoanCustomersPopup(true);
  };

  const handleDailyLoanCustomers = () => {
    setShowDailyLoanCustomersPopup(true);
  };

  const handleDailyLoanToPay = () => {
    if (!loanToPayDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select the date",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    setShowLoanToPayDailyPopup(true);
  };
  const handleWeeklyLoanToPay = () => {
    if (!loanToPayDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select the date",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    setShowLoanToPayWeeklyPopup(true);
  };

  const handleWeeklyLoanCustomers = () => {
    setShowWeeklyLoanCustomersPopup(true);
  };

  const handleCustomerChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setSelectedCustomer(value);

    if (value !== "") {
      const selectedCustomer = customers.find(
        (customer) => customer.loan_id === value
      );
      if (selectedCustomer) {
        setSelectedLoan(selectedCustomer.loan_id);
      }
    } else {
      setSelectedLoan("");
    }
  };

  const handleAdminBasedCollectionDetails = () => {
    if (!startCustDate || !endCustDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select both start date and end date",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    setShowAdminCollectionPopup(true);
  };
  const handleClosePopup = () => {
    setShowInvestmentPopup(false);
  };
  const handleNewLoansClosePopup = () => {
    setShowNewLoansPopup(false);
  };
  const handleLoanCustomersClosePopup = () => {
    setShowLoanCustomersPopup(false);
  };
  const handleDailyLoanCustomersClosePopup = () => {
    setShowDailyLoanCustomersPopup(false);
  };

  const handleWeeklyLoanCustomersClosePopup = () => {
    setShowWeeklyLoanCustomersPopup(false);
  };
  const handleDailyLoanToPayClosePopup = () => {
    setShowLoanToPayDailyPopup(false);
  };
  const handleWeeklyLoanToPayClosePopup = () => {
    setShowLoanToPayWeeklyPopup(false);
  };
  const handleInitialProfitClosePopup = () => {
    setShowInitialProfitPopup(false);
  };
  const handleCustomerLoanDetailsClosePopup = () => {
    setShowCustomerDetailsLoanPopup(false);
  };
  const handleAgentNewCustomersClosePopup = () => {
    setShowAgentNewCustomersPopup(false);
  };
  const handleAdminCollectionClosePopup = () => {
    setShowAdminCollectionPopup(false);
  };
  const handleAgentCollectionClosePopup = () => {
    setShowAgentCollectionPopup(false);
  };
  const handleAgentCustomersClosePopup = () => {
    setShowAgentCustomersPopup(false);
  };

  const handleCustomerDetails = () => {
    if (!selectedLoan) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select a Loan",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    setShowCustomerDetailsLoanPopup(true);
  };

  const handleAdminBasedNewCustomers = () => {
    if (!startDate || !endDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select both start date and end date",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    setShowAgentNewCustomersPopup(true);
  };
  useEffect(() => {
    console.log("investmentRef current:", investmentRef.current);
  }, [investmentRef]);

  const handleNewLoans = () => {
    if (!startNewLoansDate || !endNewLoansDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select both start date and end date",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }
    setShowNewLoansPopup(true);
  };
  console.log(showInvestmentPopup);

  const handleLoansInitialProfit = () => {
    if (!startLoanDate || !endLoanDate) {
      Swal.fire({
        icon: "warning",
        title: "Action Required",
        text: "Please select both start date and end date",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    setShowInitialProfitPopup(true);
  };

  return (
    <div className="bg-gray-50 min-h-screen p-6 lg:ml-64 sm:ml-0 md:ml-28">
      <h1 className="text-center text-2xl font-bold mb-6">REPORT</h1>

      <Section title="Today Collection">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={todayDate}
            onChange={handleDateChange}
            className="border  p-2  w-full sm:w-1/3 rounded-md  focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleViewClick}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3 "
          >
            View
          </button>

          {showCollectionPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 md:ml-28 sm:ml-0">
                <div
                  id="printable-collection-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <TodayCollection
                    selectedDate={formatToDisplayDate(todayDate)}
                  />
                </div>

                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={handleCollectionClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleCollectionPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      <Section title="Today Agent Collection">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={todayAgentDate}
            onChange={handleAgentDateChange}
            className="border p-2 rounded-md  w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleAdminClick}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3 "
          >
            View
          </button>

          {showAgentCollectionPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 md:ml-28 sm:ml-0">
                <div
                  id="printable-agentcollection-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <AdminCollection
                    selectedDate={formatToDisplayDate(todayAgentDate)}
                  />
                </div>
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={handleAgentCollectionClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleAgentCollectionPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      <Section title="Investment / Profit">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={investmentDate}
            onChange={handleInvestmentChange}
            className="border border-black p-2 rounded-md  focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-1/3"
          />
          <button
            onClick={handleInvestmentClick}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>

          {showInvestmentPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <InvestmentPage dateFromReport={investmentDate} />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleInvestmentPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      <Section title="Agent based Customer Details">
        <div className="flex space-x-4 items-center">
          <Select
            name="admin_id"
            options={agentOptions}
            onChange={handleAgentChange}
            value={
              selectedAgent
                ? { value: selectedAgent, label: selectedAgent }
                : null
            }
            placeholder="Select an agent"
            className="border border-black p-2 rounded-md w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <button
            onClick={handleAdminBasedCustomerDetails}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3 "
          >
            View
          </button>
          {showAgentCustomersPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-customers-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <CustomersPage agentName={allAgentNames} />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleAgentCustomersClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleAgentCustomersPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      {/* Customer Details */}
      <Section title="Customer Details">
        <div className="flex space-x-4 items-center">
          <Select
            name="customer_name"
            options={customerOptions}
            onChange={handleCustomerChange}
            value={customerOptions.find(
              (option) => option.value === selectedCustomer
            )}
            placeholder="Select a customer"
            className="border border-black p-2 w-full sm:w-1/3  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 "
          />
          {/* End Date Input */}
          <input
            type="text"
            readOnly
            value={selectedLoan}
            className="border border-black rounded-md p-2 w-full sm:w-1/3  "
          />

          <button
            onClick={handleCustomerDetails}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>

          {showCustomerDetailsLoanPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-customerDetails-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <CustomerDetailsPage loanId={selectedLoan} />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleCustomerLoanDetailsClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleCustomerLoanDetailsPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      {/* Admin Based Collection Details */}
      <Section title="Agent Based Collection Details">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={startCustDate}
            onChange={(e) => setStartCustDate(e.target.value)}
            className="border border-black rounded-md p-2  w-full sm:w-1/3"
          />

          {/* End Date Input */}
          <input
            type="date"
            value={endCustDate}
            onChange={(e) => setEndCustDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />

          <button
            onClick={handleAdminBasedCollectionDetails}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>

          {showAdminCollectionPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-admincollections-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <CollectionsPage
                    startDate={formatToDisplayDate(startCustDate)}
                    endDate={formatToDisplayDate(endCustDate)}
                  />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleAdminCollectionClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleAdminCollectionPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      {/* Customer Details */}
      <Section title="Agent based New Customers">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />

          {/* End Date Input */}
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />

          <button
            onClick={handleAdminBasedNewCustomers}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>

          {showAgentNewCustomersPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-agentnewcustomers-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <NewCustomersPage
                    startDate={formatToDisplayDate(startDate)}
                    endDate={formatToDisplayDate(endDate)}
                  />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleAgentNewCustomersClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleAgentNewCustomersPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      {/* Loan's Initial Profit Details */}
      <Section title="Loan's Initial Profit">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={startLoanDate}
            onChange={(e) => setStartLoanDate(e.target.value)}
            className="border border-black rounded-md p-2  w-full sm:w-1/3"
          />

          {/* End Date Input */}
          <input
            type="date"
            value={endLoanDate}
            onChange={(e) => setEndLoanDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />
          <button
            onClick={handleLoansInitialProfit}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>

          {showInitialProfitPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-initialprofit-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <InitialProfitPage
                    startDate={formatToDisplayDate(startLoanDate)}
                    endDate={formatToDisplayDate(endLoanDate)}
                  />
                </div>

                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={handleInitialProfitClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleInitialProfitPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      <Section title=" Loan Details">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={startNewLoansDate}
            onChange={(e) => setStartNewLoansDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />

          {/* End Date Input */}
          <input
            type="date"
            value={endNewLoansDate}
            onChange={(e) => setEndNewLoansDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />

          <button
            onClick={handleNewLoans}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>

          {showNewLoansPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-newloans-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <NewLoansPage
                    startDate={formatToDisplayDate(startNewLoansDate)}
                    endDate={formatToDisplayDate(endNewLoansDate)}
                  />
                </div>

                <div className="flex justify-end mt-4 space-x-3">
                  <button
                    onClick={handleNewLoansClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleNewLoansPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>
      <Section title="Agent-based Attendance Report">
        <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0 items-center">
          <Select
            name="agent_id"
            options={agentAttendanceOptions}
            onChange={handleAgentAttendanceChange}
            value={
              selectedAttendanceAgent
                ? agentAttendanceOptions.find(
                    (opt) =>
                      String(opt.value) === String(selectedAttendanceAgent)
                  )
                : null
            }
            placeholder="Select an agent"
            className="border border-black p-2 rounded-md w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: "38px",
              }),
            }}
          />

          <input
            type="date"
            value={startAttendanceDate}
            onChange={(e) => setStartAttendanceDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/6"
            placeholder="Start Date"
          />

          <input
            type="date"
            value={endAttendanceDate}
            onChange={(e) => setEndAttendanceDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/6"
            placeholder="End Date"
          />

          <button
            onClick={handleAdminBasedAttendanceDetails}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>
        </div>

        {showAgentAttendancePopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
              <div
                id="printable-attendance-content"
                style={{
                  fontFamily: "'Noto Sans Tamil', sans-serif",
                  fontSize: "14px",
                  color: "#000",
                }}
              >
                <AttendanceReportPage
                  agentId={selectedAttendanceAgent}
                  startDate={startAttendanceDate}
                  endDate={endAttendanceDate}
                />
              </div>

              <div className="flex justify-end mt-4 space-x-2">
                <button
                  onClick={handleAgentAttendanceClosePopup}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Close
                </button>
                <button
                  onClick={handleAgentAttendancePrint}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Export as PDF
                </button>
              </div>
            </div>
          </div>
        )}
      </Section>

      <Section title="Agent-based Advance Report">
        <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0 items-center">
          <Select
            name="agent_id"
            options={agentAdvanceOptions}
            onChange={handleAgentAdvanceChange}
            value={
              selectedAdvanceAgent
                ? agentAdvanceOptions.find(
                    (opt) => String(opt.value) === String(selectedAdvanceAgent)
                  )
                : null
            }
            placeholder="Select an agent"
            className="border border-black p-2 rounded-md w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: "38px",
              }),
            }}
          />

          <input
            type="date"
            value={startAdvanceDate}
            onChange={(e) => setStartAdvanceDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/6"
            placeholder="Start Date"
          />

          <input
            type="date"
            value={endAdvanceDate}
            onChange={(e) => setEndAdvanceDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/6"
            placeholder="End Date"
          />

          <button
            onClick={handleAgentAdvanceDetails}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            View
          </button>
        </div>

        {showAgentAdvancePopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
              <div
                id="printable-advance-content"
                style={{
                  fontFamily: "'Noto Sans Tamil', sans-serif",
                  fontSize: "14px",
                  color: "#000",
                }}
              >
                <AdvanceReportPage
                  agentId={selectedAdvanceAgent}
                  startDate={startAdvanceDate}
                  endDate={endAdvanceDate}
                />
              </div>

              <div className="flex justify-end mt-4 space-x-2">
                <button
                  onClick={handleAgentAdvanceClosePopup}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Close
                </button>
                <button
                  onClick={handleAgentAdvancePrint}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Export as PDF
                </button>
              </div>
            </div>
          </div>
        )}
      </Section>

      {/* Loan to Pay*/}
      <Section title="Loan to pay Customer details">
        <div className="flex space-x-4 items-center">
          <input
            type="date"
            value={loanToPayDate}
            onChange={(e) => setLoanToPayaDate(e.target.value)}
            className="border border-black rounded-md p-2 w-full sm:w-1/3"
          />

          <button
            onClick={handleDailyLoanToPay}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            Daily
          </button>
          {showLoanToPayDailyPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-dailyloantopay-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <DailyLoanToPayPage
                    selectedDate={formatToDisplayDate(loanToPayDate)}
                  />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleDailyLoanToPayClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleDailyLoanToPayPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}

          <button
            onClick={handleWeeklyLoanToPay}
            className="bg-blue-500 text-white px-4 py-2 rounded-md w-full sm:w-1/3"
          >
            Weekly
          </button>

          {showLoanToPayWeeklyPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
                <div
                  id="printable-weeklyloantopay-content"
                  style={{
                    fontFamily: "'Noto Sans Tamil', sans-serif",
                    fontSize: "14px",
                    color: "#000",
                  }}
                >
                  <WeeklyLoanToPayPage
                    selectedDate={formatToDisplayDate(loanToPayDate)}
                  />
                </div>

                <div className="flex justify-end mt-4 space-x-2">
                  <button
                    onClick={handleWeeklyLoanToPayClosePopup}
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleWeeklyLoanToPayPrint}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                  >
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Section>

      <div className="flex space-x-4">
        <button
          onClick={handleLoanCustomers}
          className="bg-blue-500 text-white px-4 py-2 rounded-md w-1/3"
        >
          Loan Customers
        </button>
        {showLoanCustomersPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
              <div
                id="printable-loancustomers-content"
                style={{
                  fontFamily: "'Noto Sans Tamil', sans-serif",
                  fontSize: "14px",
                  color: "#000",
                }}
              >
                <LoanCustomersPage />
              </div>

              <div className="flex justify-end space-x-2 mt-4">
                <button
                  onClick={handleLoanCustomersClosePopup}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                >
                  Close
                </button>
                <button
                  onClick={handleLoanCustomersPrint}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                >
                  Export as PDF
                </button>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={handleDailyLoanCustomers}
          className="bg-blue-500 text-white px-4 py-2 rounded-md w-1/3"
        >
          Daily Loan Customers
        </button>

        {showDailyLoanCustomersPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
              <div
                style={{
                  fontFamily: "'Noto Sans Tamil', sans-serif",
                  fontSize: "14px",
                  color: "#000",
                }}
              >
                <DailyLoanCustomers />
              </div>

              <div className="flex justify-end mt-4 space-x-2">
                <button
                  onClick={handleDailyLoanCustomersClosePopup}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                >
                  Close
                </button>
                <button
                  onClick={handleDailyLoanCustomersPrint}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                >
                  Export as PDF
                </button>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={handleWeeklyLoanCustomers}
          className="bg-blue-500 text-white px-4 py-2 rounded-md w-1/3"
        >
          Weekly Loan Customers
        </button>

        {showWeeklyLoanCustomersPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-h-[90vh] overflow-auto relative lg:ml-64 sm:ml-0">
              <div
                style={{
                  fontFamily: "'Noto Sans Tamil', sans-serif",
                  fontSize: "14px",
                  color: "#000",
                }}
              >
                <WeeklyLoanCustomers />
              </div>

              <div className="flex justify-end mt-4 space-x-2">
                <button
                  onClick={handleWeeklyLoanCustomersClosePopup}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 close-button"
                >
                  Close
                </button>
                <button
                  onClick={handleWeeklyLoanCustomersPrint}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print-button"
                >
                  Export as PDF
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Section = ({ title, children }) => {
  return (
    <div className="bg-white shadow-sm rounded-md p-4 mb-6">
      <h2 className="text-lg font-bold mb-4">{title}</h2>
      {children}
    </div>
  );
};

export default ReportPage;
